import { create } from "zustand";

type UseShowPollenNavStoreType = {
  showPollenNav: boolean;
  setShowPollenNav: (val: boolean) => void;
  resetShowPollenNav: () => void;
};

const initialState = {
  showPollenNav: false,
};

const useShowPollenNavStore = create<UseShowPollenNavStoreType>(set => ({
  ...initialState,
  setShowPollenNav: val => set({ showPollenNav: val }),
  resetShowPollenNav: () => set(initialState),
}));

export default useShowPollenNavStore;
